import { SerializedStyles, css } from '@emotion/react';

const primaryButton = css({
    '&:not(:disabled)': {
        backgroundColor: 'var(--custom-action-color)',
        color: 'var(--custom-text-color)',
    },

    '&:disabled': {
        backgroundColor: '#F5F7F9',
    },

    borderRadius: 'var(--radius-component, 6px)',
    padding: '8px 12px',
    lineHeight: '20px',

    '&:not(:disabled):hover': {
        backgroundColor: 'var(--custom-action-color-hover)',
    },
});

const secondaryButton = ({ isLoading }: { isLoading: boolean }): SerializedStyles =>
    css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,

        backgroundColor: '#F5F7F9',
        color: '#647491',
        outline: '1px solid var(--border-color, #D3DBE5)',
        borderRadius: 'var(--radius-component, 6px)',
        padding: '8px 11px',
        lineHeight: '20px',

        '&:disabled': {
            cursor: 'default',
        },

        ...(isLoading && {
            '&:hover': {
                cursor: 'progress',
            },
        }),
    });

const addedToCartButton = css(secondaryButton({ isLoading: false }), {
    '& svg': {
        fill: '#34B857',
        width: 20,
        height: 20,
    },
});

const addingToCartButton = css(secondaryButton({ isLoading: true }), {
    '& svg.loader-icon': {
        position: 'static',
    },
});

export default { primaryButton, addedToCartButton, addingToCartButton };
